module.exports = __webpack_public_path__ + "assets/images/cone_e46e09714848f2b5c5991410d895eeb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cone/cone.png
// module id = 191
// module chunks = 0